<template>
    <div class="part4_hd" ref="part4Nav" :class="{ 'scroll_fix': isNavFixed}">
        <div class="part4_hd_box fix"  >
            <ul class="fix f-fl nav">
                <li v-if="isFeaturesShow" class="f-fl" :class="{ active: activeMenu[0]}" @click="goSection(0)">
                  <a class="nav_box">游轮特色</a>
                </li>
                <li class="f-fl" :class="{ active: activeMenu[1]}" @click="goSection(1)">
                    <a class="nav_box">航程介绍</a>
                </li>
                <li class="f-fl" :class="{ active: activeMenu[2]}" @click="goSection(2)">
                    <a class="nav_box">费用说明</a>
                </li>
                <li class="f-fl" :class="{ active: activeMenu[3]}" @click="goSection(3)">
                    <a class="nav_box">签证及保险</a>
                </li>
                <li class="f-fl" :class="{ active: activeMenu[4]}" @click="goSection(4)">
                    <a class="nav_box">预订及退改</a>
                </li>
                <li class="f-fl" :class="{ active: activeMenu[5]}" @click="goSection(5)">
                    <a class="nav_box">支付及发票</a>
                </li>
                <li class="f-fl" :class="{ active: activeMenu[6]}" @click="goSection(6)" v-show="isShowReview">
                    <a class="nav_box">游记</a>
                </li>
            </ul>
            <div class="f-fr">
                <span class="room_num all_room_num cursor-pointer" @click="showShoppingCart()">{{shoppingCarts.length}}间</span>
                <span class="totle_price"><em class="price_title">总价：</em><em class="unit">￥</em> <em class="price_num all_price_num">{{totalAmount.toFixed(0)}}</em></span>
                <SubmitShoppingCartButton class="next_btn" :shoppingCarts="shoppingCarts"/>
            </div>
        </div>
    </div>
</template>

<script>
const SubmitShoppingCartButton = () => import('@/components/Cruise/CruiseDetail/SubmitShoppingCartButton.vue')
export default {
    name: "CruiseDetailNav",
    components: {
        SubmitShoppingCartButton
    },
    props: {
        shoppingCarts: {
            type: Array
        },
        isShowReview: {
            type: Boolean
        },
        isFeaturesShow: {
          type: Boolean
        }
    },
    data () {
        return {
            isNavFixed: false,
            activeMenu: [true, false, false, false, false, false, false]
        }
    },
    beforeMount () {
        if(!this.isFeaturesShow) {
          this.activeMenu = [false, true, false, false, false, false, false]
        }
        window.addEventListener('scroll', this.scrollHandler)
    },
    beforeDestroy () {
        window.removeEventListener('scroll', this.scrollHandler)
    },
    methods: {
        scrollHandler () {
            if (this.$router.currentRoute.name != "CruiseDetail") return
            if(this.isFeaturesShow) {
              if (!document.getElementById('section1')) return
            }
            if (!document.getElementById('section2')) return
            if (!document.getElementById('section3')) return

            const part4Top = this.$refs.part4Nav.getBoundingClientRect().top
            if (part4Top < 0) {
                this.isNavFixed = true
            } else {
                this.isNavFixed = false
            }

            let section1 = 0;
            if(this.isFeaturesShow) {
              section1 = document.getElementById('section1').getBoundingClientRect().top
            }
            const section2 = document.getElementById('section2').getBoundingClientRect().top
            const section3 = document.getElementById('section3').getBoundingClientRect().top
            const section4 = document.getElementById('section4').getBoundingClientRect().top
            const section5 = document.getElementById('section5').getBoundingClientRect().top
            const section6 = document.getElementById('section6').getBoundingClientRect().top
            const section7 = document.getElementById('section7').getBoundingClientRect().top

            this.activeMenu = [false, false, false, false, false, false, false]
            const offset = 85
            if (section7 < offset) {
              this.$set(this.activeMenu, 6, true)
            } else if (section6 < offset) {
                this.$set(this.activeMenu, 5, true)
            } else if (section5 < offset) {
                this.$set(this.activeMenu, 4, true)
            } else if (section4 < offset) {
                this.$set(this.activeMenu, 3, true)
            } else if (section3 < offset) {
                this.$set(this.activeMenu, 2, true)
            } else if (section2 < offset) {
                this.$set(this.activeMenu, 1, true)
            } else if (section1 < offset && this.isFeaturesShow) {
                this.$set(this.activeMenu, 0, true)
            }
        },
        goSection (index) {
            const sectionName = "section" + (index+1)
          console.log(sectionName)
            const section = document.getElementById(sectionName)
            window.scroll({
                top: section.getBoundingClientRect().top + window.scrollY - 80,
                behavior: 'smooth'
            })
        },
        showShoppingCart () {
            this.$store.commit('SET_LEFT_MENU', 1)
        }
    },
    computed: {
         totalAmount () {
            let amount = 0
            this.shoppingCarts.forEach(shoppingCart => {
                amount += shoppingCart.amount
            })
            return amount
        },
    }
}
</script>

<style lang="less" scoped>
.part4_hd {
    border-bottom: 2px solid #e7f5ff;
    background: #fff;
    height: 45px;
    overflow: hidden;
    ul {
        margin-bottom: 0;
    }
    .nav_box {
        font-size: 16px;
        line-height: 50px;
        padding: 0 20px;
        display: block;
        color: black;
        cursor: pointer;
    }
    .active .nav_box {
        color: #ffa70d;
        background: transparent;
        border-bottom: 2px solid #ffa70d;
        text-decoration: none;
    }
    .nav_box:hover {
        color: #ffa70d;
        background: transparent;
        text-decoration: none;
    }
    .f-fr {
        display: none;
    }
}
.scroll_fix {
    .part4_hd_box {
        position: fixed;
        width: 1200px;
        top: 0;
        // left: 50%;
        // margin-left: -600px;
        z-index: 100;
        background: #fffbec;
        border: 1px solid #fbc500;
    }
    .f-fr {
        display: block;
        text-align: right;
        .room_num {
            color: #0073bb;
            position: relative;
            cursor: pointer;
        }
        span {
            display: inline-block;
            margin-left: 30px;
            vertical-align: middle;
            line-height: 52px;
            height: 52px;
        }
        .room_num:after {
            content: '';
            display: block;
            width: 1px;
            height: 12px;
            background: #a6aeb1;
            position: absolute;
            top: 19px;
            right: -19px;
        }
        .totle_price {
            em {
                display: inline-block;
                vertical-align: text-bottom;
                font-style: normal;
            }
            .unit {
                color: #ff3022;
                font-weight: bold;
            }
            .price_num {
                color: #ff3022;
                font-size: 30px;
                font-weight: bold;
            }
        }
        .next_btn {
            font-size: 18px;
            color: #282b2c;
            background: #fbc500;
            padding: 0 30px;
            cursor: pointer;
            display: inline-block;
            margin-left: 30px;
            vertical-align: middle;
            line-height: 52px;
            height: 52px;
        }
    }
}
</style>
